import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { forgotPasswordInitial,forgotPasswordSchema} from '../../validations/authValidations';
import { closeForgotPasswordModal} from '../../stores/slices/commonSlice';
import {Formik,ErrorMessage,Field,Form} from "formik";
import { IoMdClose } from "react-icons/io";
import { useSelector, useDispatch } from 'react-redux';
import { useState } from 'react';
import { forgotPasswordAction } from "../../stores/actions/authActions";

export default function ForgotPassword(){
    const dispatch = useDispatch();
    const openForgotPassword=useSelector(state=>state.common.forgotPasswordModal);
    const [button,setButton]=useState("Submit");
    const [disabled,setDisabled]=useState(false);
    
    const forgotPassword=async(values)=>{
      setDisabled(true);
      setButton("Please wait ....");
      dispatch(forgotPasswordAction(values)).then(response=>{
          if(response.meta.requestStatus=="fulfilled"){
              setDisabled(false);
              setButton("Submit");
              dispatch(closeForgotPasswordModal());
          }else{
              setDisabled(false);
              setButton("Submit");
          }
      });
    }

    const handleClose = () => {
      dispatch(closeForgotPasswordModal());
    }
return (
    <>
 <Dialog className='final-reset'
        open={openForgotPassword}
      >
        <DialogContent className='reset-box' sx={{width:600,p:0}}>
        <div className='loginBoxHeader d-flex justify-content-between'>
            {/* <div className='loginBox-content d-flex align-items-center justify-content-between'> */}
            <img src="/assets/images/apsession-won-icon.png" width="60"/>
            <h2 className='ml-3'>Reset Password</h2>
            {/* </div> */}
            <IoMdClose className='closeModalIcon' onClick={handleClose}/>
        </div>
        
        <div className='loginFormBox'>
         <Formik initialValues={forgotPasswordInitial} validationSchema={forgotPasswordSchema}
          onSubmit={(values,{setSubmitting})=>{
            forgotPassword(values);
          }}
         >
         <Form>
      <div className='form-group mb-3'>
        <label htmlFor="" >Please enter your email address</label>
        <Field type="email" name="email" id="" className='form-control' placeholder='Email' />
        <ErrorMessage name='email' component="p" className='errorMessage'/>
      </div>
      <div className='form-group'>
      <button className='login-btn' disabled={disabled}>{button}</button>
      </div>
       </Form>
         </Formik>
        </div>
        </DialogContent>
      </Dialog>
    </>
);
}
